const HeaderStyle = {
    nav: {
        height: '61px',

        header: {
            height: '80px',
            backgroundImage: 'url(./assets/images/headerBg.png)',
            borderBottom: 'solid 1px #f6f6f6',
            container: {
                height: '100%'
            }
        },
        item: {
            fontWeight: '500',
            padding: '0 0.5em',
            cursor: 'pointer'
        },
        greeting: {
            fontWeight: '500',
            color: '#000',
            padding: '0 0.5em'
        },

        main: {
            flexGrow: '1',
            textAlign: 'left'

        },
        right: {
            fontSize: '1em',
            flexGrow: '1',
            textAlign: 'right'
        },
        left: {
            fontSize: '18px',
            color: '#ffffff',
            flexGrow: '1',
            width: '300px',
            textAlign: 'center'
        }
    }
}
export default HeaderStyle
